import TranslationsContext from 'contexts/TranslationsContext';
import { useContext } from 'react';

const useTranslation = () => useContext(TranslationsContext);

export default useTranslation;
